import { render, staticRenderFns } from "./LeonidaFederazioniSportiveNazionaliList.vue?vue&type=template&id=5a4e4a6a"
import script from "./LeonidaFederazioniSportiveNazionaliList.vue?vue&type=script&lang=js"
export * from "./LeonidaFederazioniSportiveNazionaliList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports